export class SearchProducts {
  static readonly type = '[Search] SearchProducts';

  constructor(public searchString: string) {}
}

export class SearchProductsStart {
  static readonly type = '[Search] SearchProductsStart';
}

export class ClearSearchResults {
  static readonly type = '[Search] ClearSearchResults';
}

export class QuickSearch {
  static readonly type = '[Search] QuickSearch';

  constructor(public searchString: string) {}
}
